import { normalizePlanCode } from '../../../../../shared/plan-benefits';

export function shouldShowLegacyCreceHomeNudge(input: {
  billingEnabled: boolean;
  isOwner: boolean | undefined;
  planCode: string | null | undefined;
  volumeNear: boolean;
}): boolean {
  if (!input.billingEnabled || input.isOwner !== true) return false;
  if (normalizePlanCode(input.planCode) !== 'legacy') return false;
  if (input.volumeNear) return false;
  return true;
}
